import { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";

import KogModalSideComponent from "@/main/components/modal/ModalSide";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { Controls } from "@/main/services/constants/constantsControl";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";

import * as S from "../styles";
import { useThreeDotsClaimContext } from "../contex";
import { ModalAudit } from "@/main/screens/order/viewOrder/components/modalAudit/modalAudit";
import { procurementApi } from "@/main/api";
import { GetAuditByClaimResponse, ProcurementHeaderViewOrderResponse } from "@/main/models/response";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { CompanyTypeEnum } from "@/main/services/enum/CompanyTypeEnum";
import { userIsBodyshop } from "@/main/services/utilsUser";

interface IThreeDotsClaimAuditProps {
	guidClaim: string;
	hasProcurement: boolean;
}
function ThreeDotsClaimAudit({ guidClaim, hasProcurement }: IThreeDotsClaimAuditProps) {
	const { closeThreeDotsClaim, generateIdMenu } = useThreeDotsClaimContext();
	const [isOpenModalAudit, setIsOpenModalAudit] = useState<boolean>(false);
	const [audits, setAudits] = useState<GetAuditByClaimResponse[]>([]);
	const [isLoadAudit, setIsLoadAudit] = useState<boolean>(false);
	const [dataHeader] = useState<ProcurementHeaderViewOrderResponse | null>(null);

	function handleClick() {
		setIsOpenModalAudit(true);
		closeThreeDotsClaim();
	}
	function closeModal() {
		closeThreeDotsClaim();
		setIsOpenModalAudit(false);
	}
	useEffect(() => {
		if (!isOpenModalAudit) return;
		setIsLoadAudit(true);
		procurementApi
			.getQuoteAuditDataByClaim({ guidClaim })
			.then((response) => {
				const {
					data: { result },
				} = response;
				setAudits(result);
			})
			.finally(() => {
				setIsLoadAudit(false);
			});
	}, [isOpenModalAudit]);

	// Core function
	function canSeeAuditButton(): boolean {
		if ((userIsBodyshop() && dataHeader?.idBuyerCompanyType == CompanyTypeEnum.Insurer) || !hasProcurement)
			return false;
		return isShowControlByElementId(Controls.IdShowAudit);
	}

	return (
		<>
			{canSeeAuditButton() && (
				<MenuItem id={generateIdMenu("audit")} onClick={handleClick}>
					{getTranslateByKey("information.audit")}
				</MenuItem>
			)}
			{isOpenModalAudit && (
				<KogModalSideComponent
					shouldRenderOpen
					width="850px"
					open={isOpenModalAudit}
					title={getTranslateByKey("information.audit")}
					closeModal={() => setIsOpenModalAudit(false)}
				>
					{isLoadAudit ? (
						<LoadingComponent />
					) : (
						audits.map((audit) => (
							<ModalAudit
								key={audit.codeProcurement}
								auditParameters={audit.auditParameter}
								gridData={audit.audit}
								isLoadingData={isLoadAudit}
								isLoadingDataParameterAudit={isLoadAudit}
								orderNumber={audit.codeProcurement}
								quoteDateFormatted={audit.quoteDateFormatted}
								guidProcurement={""}
								handleModalAudit={closeModal}
							/>
						))
					)}
					<S.FooterButtonHistory>
						<SecondaryButton id="id-createOrder-button-back" onClick={() => closeModal()}>
							{getTranslateByKey("information.back")}
						</SecondaryButton>
					</S.FooterButtonHistory>
				</KogModalSideComponent>
			)}
		</>
	);
}

export { ThreeDotsClaimAudit };
